<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="搜索内容">
      <a-input v-model="form.data.value"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!hotSearchId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="hotSearchId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryHotSearch,
  _addHotSearch,
  _updateHotSearch,
} from '@/api/hotSearchApi';

async function getHotSearch() {
  const result = await _queryHotSearch(this.hotSearchId);
  if (result) {
    this.form.data.value = result.value;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addHotSearch({
        value: this.form.data.value,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateHotSearch(this.hotSearchId, {
        value: this.form.data.value,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'HotSearchEdit',
  props: {
    hotSearchId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    hotSearchId() {
      if (this.hotSearchId) {
        this.getHotSearch();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getHotSearch,
  },
  data() {
    return {
      form: {
        data: {
          value: '',
        },
        rules: {
          value: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.hotSearchId) {
      this.getHotSearch();
    }
  },
};
</script>
